// extracted by mini-css-extract-plugin
export var base = "_3x-0";
export var updateBanner = "_3x-1";